/* Galleria a mosaico — apertura a elemento condiviso, senza librerie.

   Il riferimento (21st.dev, "Shared Element Gallery") usa framer-motion per far
   sembrare che la foto della griglia SIA la foto ingrandita. Oggi quel gesto lo
   fa il browser da solo: si da' lo stesso `view-transition-name` alla miniatura
   e all'ingrandimento, e `startViewTransition` interpola fra i due.
   Dove non e' supportato non si rompe niente: resta un'apertura secca. */

(function () {
  'use strict';

  function avvia(radice) {
    /* `mosaico` puo' non esserci: la stessa lastra la usa anche la scheda
       prodotto, che non ha la griglia a colonne ma solo delle foto da
       ingrandire. Quello che serve davvero e' la lastra piu' un elemento
       marcato `data-ingrandisci` su cui premere. */
    var mosaico = radice.querySelector('.mosaico');
    var lastra = radice.querySelector('.mosaico__lastra');
    var grande = radice.querySelector('.mosaico__grande');
    var nota = radice.querySelector('.mosaico__nota');
    if (!lastra || !grande) return;

    var apertaDa = null;
    var conTransizione = typeof document.startViewTransition === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Le foto entrano quando la sezione arriva in vista, non al caricamento:
       animare qualcosa che sta fuori schermo vuol dire non farlo vedere. */
    if (mosaico) {
      if ('IntersectionObserver' in window) {
        var occhio = new IntersectionObserver(function (voci) {
          voci.forEach(function (v) {
            if (v.isIntersecting) { mosaico.classList.add('mosaico--dentro'); occhio.disconnect(); }
          });
        }, { threshold: 0.12 });
        occhio.observe(mosaico);
      } else {
        mosaico.classList.add('mosaico--dentro');
      }

      /* ritardo crescente: le foto entrano una dopo l'altra, non in blocco */
      Array.prototype.forEach.call(mosaico.querySelectorAll('.mosaico__voce'), function (v, i) {
        v.style.transitionDelay = (i * 0.06) + 's';
      });
    }

    /* Il velo scuro e sfocato dietro la foto. Va acceso DOPO che il <dialog> e'
       passato da `display: none` a visibile: nello stesso fotogramma il
       browser non ha uno stato di partenza da cui interpolare, e la sfocatura
       comparirebbe di colpo — che e' il difetto da togliere. Due
       `requestAnimationFrame` sono la garanzia che il fotogramma sia passato. */
    function velo(acceso) {
      if (!acceso) { lastra.classList.remove('mosaico__lastra--velo'); return; }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { lastra.classList.add('mosaico__lastra--velo'); });
      });
    }

    /* Quando esiste una versione piu' grande, NON si apre con quella: si apre
       con la foto gia' in pagina e la si sostituisce dopo, a decodifica
       finita. Cosi' non c'e' nessun istante in cui la lastra e' vuota, e lo
       scambio non si vede perche' e' la stessa immagine a piu' risoluzione. */
    function meglio(via) {
      if (!via) return;
      var pre = new Image();
      var messa = function () { if (lastra.open) grande.src = via; };
      pre.src = via;
      if (pre.decode) pre.decode().then(messa).catch(function () {});
      else pre.onload = messa;
    }

    function apri(voce) {
      var img = voce.querySelector('img');
      if (!img) return;
      apertaDa = voce;
      /* ⚠ La transizione deve partire da pixel che ESISTONO gia'. Puntando
         subito la versione grande — che sulle schede prodotto e' un altro
         file, da 2000px, non ancora scaricato — l'ingrandimento partiva da
         un'immagine vuota: la foto si rimpiccioliva, spariva e ricompariva.
         In homepage non si notava perche' li' la lastra apre lo stesso file
         gia' in pagina. */
      var subito = img.currentSrc || img.src;
      var alta = voce.dataset.grande || img.dataset.grande || '';
      /* ⚠ La misura della lastra si fissa QUI, dalle proporzioni della foto,
         e non la decide il file. Aperta con la miniatura, la foto prendeva la
         larghezza della miniatura e poi saltava a tutto schermo all'arrivo
         di quella da 2000px. Su uno schermo ad alta densita' la miniatura e'
         gia' grande e il salto non si vede; su uno schermo normale si' (il PC
         della moglie di Richard, 29 settembre). */
      if (img.naturalWidth && img.naturalHeight) {
        grande.style.setProperty('--rapporto', img.naturalWidth / img.naturalHeight);
      }
      var fai = function () {
        grande.src = subito;
        grande.alt = img.alt || '';
        if (nota) nota.textContent = img.alt || '';
        img.style.viewTransitionName = '';
        grande.style.viewTransitionName = 'foto-aperta';
        lastra.showModal();
        velo(true);
        meglio(alta);
      };
      if (!conTransizione) { fai(); return; }
      img.style.viewTransitionName = 'foto-aperta';
      document.startViewTransition(fai);
    }

    function chiudi() {
      /* si spegne subito, cosi' la prossima apertura riparte da trasparente */
      velo(false);
      var fai = function () {
        lastra.close();
        grande.style.viewTransitionName = '';
        if (apertaDa) {
          var img = apertaDa.querySelector('img');
          if (img) img.style.viewTransitionName = '';
        }
      };
      if (!conTransizione) { fai(); return; }
      grande.style.viewTransitionName = 'foto-aperta';
      if (apertaDa) {
        var i2 = apertaDa.querySelector('img');
        if (i2) i2.style.viewTransitionName = '';
      }
      var t = document.startViewTransition(function () {
        lastra.close();
        grande.style.viewTransitionName = '';
        if (apertaDa) {
          var i3 = apertaDa.querySelector('img');
          if (i3) i3.style.viewTransitionName = 'foto-aperta';
        }
      });
      t.finished.finally(function () {
        if (apertaDa) {
          var i4 = apertaDa.querySelector('img');
          if (i4) i4.style.viewTransitionName = '';
        }
      });
    }

    radice.addEventListener('click', function (e) {
      var voce = e.target.closest('[data-ingrandisci]');
      if (voce && radice.contains(voce)) apri(voce);
    });

    lastra.addEventListener('click', function (e) {
      /* clic fuori dalla foto: si chiude. Sulla foto no, altrimenti non si
         puo' guardarla senza chiuderla per sbaglio. */
      if (e.target === lastra || e.target.closest('.mosaico__chiudi')) chiudi();
    });
    grande.addEventListener('click', chiudi);

    /* <dialog> chiude da solo con Esc: si intercetta per fare la transizione
       invece della sparizione secca. */
    lastra.addEventListener('cancel', function (e) { e.preventDefault(); chiudi(); });

    /* Trascinamento per chiudere, come nel riferimento: si tira la foto e
       quando ha fatto abbastanza strada si chiude. Sotto la soglia torna al
       suo posto, cosi' un trascinamento incerto non chiude per sbaglio. */
    var partenza = null;
    grande.addEventListener('pointerdown', function (e) {
      partenza = { x: e.clientX, y: e.clientY };
      grande.setPointerCapture(e.pointerId);
      grande.style.transition = 'none';
    });
    grande.addEventListener('pointermove', function (e) {
      if (!partenza) return;
      var dy = e.clientY - partenza.y;
      grande.style.transform = 'translateY(' + dy + 'px)';
      grande.style.opacity = String(Math.max(0.25, 1 - Math.abs(dy) / 420));
    });
    var molla = function (e) {
      if (!partenza) return;
      var dy = e.clientY - partenza.y;
      partenza = null;
      grande.style.transition = 'transform .28s cubic-bezier(.2,.8,.3,1), opacity .28s ease';
      grande.style.transform = '';
      grande.style.opacity = '';
      if (Math.abs(dy) > 120) chiudi();
    };
    grande.addEventListener('pointerup', molla);
    grande.addEventListener('pointercancel', molla);
  }

  function tutte() {
    document.querySelectorAll('[data-mosaico]').forEach(function (r) {
      if (!r.dataset.mosaicoAvviato) { r.dataset.mosaicoAvviato = '1'; avvia(r); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
